export const ENUM_PERMISSIONS_LIST = "ENUM_PERMISSIONS_LIST"
export const ENUM_PERMISSIONS_LIST_SUCCESS = "ENUM_PERMISSIONS_LIST_SUCCESS"
export const ENUM_PERMISSIONS_LIST_ERROR = "ENUM_PERMISSIONS_LIST_ERROR"
